/* istanbul ignore file */
import React from 'react';
import _ from 'underscore';
import { getODataErrors } from '@bingads-webui-campaign/api-errors';

const getUnexpectedError = i18n => ([{
  message: i18n.getString('IMA_Reach_Representation_Api_General_Error'),
}]);

const getOdataResponseErrors = (response, i18n) => {
  if (!response || !response.errors) {
    return getUnexpectedError(i18n);
  }

  const errors = getODataErrors(response.errors, i18n);

  if (!errors || !errors[0] || !errors[0].message) {
    return getUnexpectedError(i18n);
  }

  // error is a api error class
  return _.map(errors, error => ({ message: error.message }));
};

export const errorHandler = (WrappedComponent, i18n) => (err) => {
  const errorMessage = getOdataResponseErrors(err, i18n);
  const message = _.pluck(errorMessage, 'message').length > 0 ? _.pluck(errorMessage, 'message')[0] : '';

  if (message) {
    const { alertCenter } = (window && window.App && window.App.views) || {};
    if (alertCenter && _.isFunction(alertCenter.showError)) {
      alertCenter.showError(message);
    }
  }

  return (<WrappedComponent audienceFromOData={{ dataNotReady: true }} />);
};
